<template>
  <div class="sub-agent-invite-panel">
    <div class="time-tab-wrap">
      <div ref="timeTabList" class="time-switch-tab">
        <div
          v-for="(tab, index) in timeTabs"
          :key="tab.key"
          :ref="`timeTab-${index}`"
          class="time-tab"
          :class="{ 'active-tab': timeTabIndex === index }"
          @click="handleTimeTab(index)"
        >
          {{ $t(tab.labelKey) }}
        </div>
      </div>
    </div>
    <SubAgentNoticeBar :notices="notices" />
    <!-- New Sub-agent -->
    <div class="data-section">
      <div class="section-header">
        <span class="section-bar"></span>
        <span class="section-title">{{ $t('lang.Invite.k092') }}</span>
      </div>
      <div class="stat-cards stat-cards-row">
        <div class="stat-card-row">
          <span class="stat-label">{{ $t('lang.Invite.k093') }}</span>
          <span class="stat-value">{{ stats.newSubAgents }}</span>
        </div>
      </div>
      <div class="data-table">
        <div class="table-header">
          <div class="th th-agent">{{ $t('lang.Invite.k089') }}</div>
          <div class="th">{{ $t('lang.Invite.k090') }}</div>
          <div class="th">{{ $t('lang.Invite.k011') }}</div>
        </div>
        <div v-for="item in newSubAgentList" :key="item.presentId" class="table-row">
          <div class="td td-agent">
            <div class="agent-name-row">
              <span class="agent-name">{{ item.nickname }}</span>
              <img v-if="item.locationFlag" class="country-icon" :src="item.locationFlag | imgPath" alt="" />
            </div>
            <div class="agent-id-row" @click="handleCopyId(item.presentId)">
              <span>ID:{{ item.presentId }}</span>
              <img class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp" alt="" />
            </div>
          </div>
          <div class="td td-center">{{ item.joined }}</div>
          <div class="td td-center">{{ item.totalHostess }}</div>
        </div>
        <div v-if="!inviteLoading && !newSubAgentList.length" class="table-empty"></div>
      </div>
      <div v-if="showNewViewMore" class="view-more" @click="goNewSubAgentPage">
        <span>{{ $t('lang.Invite.k085') }}</span>
        <img class="view-more-arrow ar-arrow" src="@/assets/packageAssets/common/arrow15.webp" alt="" />
      </div>
    </div>
    <div class="section-divider"></div>
    <!-- Sub-agent Performance -->
    <div class="data-section">
      <div class="section-header">
        <span class="section-bar"></span>
        <span class="section-title">{{ $t('lang.Invite.k094') }}</span>
      </div>
      <div class="stat-cards three-cols">
        <div class="stat-card">
          <div class="stat-value">{{ stats.newHostCount }}</div>
          <div class="stat-label">
            <p>{{ $t('lang.Invite.k091') }}</p>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ stats.hasInviteAgentCount }}</div>
          <div class="stat-label">
            <p>{{ $t('lang.Invite.k095') }}</p>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ stats.noInviteAgentCount }}</div>
          <div class="stat-label">
            <p>{{ $t('lang.Invite.k096') }}</p>
          </div>
        </div>
      </div>
      <div class="data-table">
        <div class="table-header">
          <div class="th th-agent">{{ $t('lang.Invite.k089') }}</div>
          <div class="th th-with-tip">{{ $t('lang.Invite.k091') }}</div>
          <div class="th">{{ $t('lang.Invite.k011') }}</div>
        </div>
        <div v-for="item in performanceList" :key="item.presentId" class="table-row">
          <div class="td td-agent">
            <div class="agent-name-row">
              <span class="agent-name">{{ item.nickname }}</span>
              <img v-if="item.locationFlag" class="country-icon" :src="item.locationFlag | imgPath" alt="" />
            </div>
            <div class="agent-id-row" @click="handleCopyId(item.presentId)">
              <span>ID:{{ item.presentId }}</span>
              <img class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp" alt="" />
            </div>
          </div>
          <div class="td td-center">{{ item.newHostess }}</div>
          <div class="td td-center">{{ item.totalHostess }}</div>
        </div>
        <div v-if="!inviteLoading && !performanceList.length" class="table-empty"></div>
      </div>
      <div v-if="showPerformanceViewMore" class="view-more" @click="goPerformancePage">
        <span>{{ $t('lang.Invite.k085') }}</span>
        <img class="view-more-arrow ar-arrow" src="@/assets/packageAssets/common/arrow15.webp" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import SubAgentNoticeBar from './components/NoticeBar.vue'
import carouselPollMixin from './hooks/carousel-poll.mixin.js'
import { apiFetchSubAgentCarousel, apiFetchSubAgentInvite } from '@/api/invite'
import {
  INVITE_DATA_TYPE,
  PREVIEW_DISPLAY_LIMIT,
  PREVIEW_FETCH_LIMIT,
  TIME_TABS_INVITE,
  buildInviteParams,
  mapCarouselList,
  mapSubAgentStatItem,
} from './utils/index'
export default {
  name: 'SubAgentInviteTab',
  components: { SubAgentNoticeBar },
  mixins: [carouselPollMixin],
  data() {
    return {
      timeTabIndex: 0,
      timeTabs: TIME_TABS_INVITE,
      newSubAgentList: [],
      performanceList: [],
      notices: [],
      newSubAgentCount: 0,
      hasInviteAgentCount: 0,
      newHostCount: 0,
      noInviteAgentCount: 0,
      showNewViewMore: false,
      showPerformanceViewMore: false,
      inviteLoading: false,
    }
  },
  computed: {
    stats() {
      return {
        newSubAgents: this.newSubAgentCount,
        newHostCount: this.newHostCount,
        hasInviteAgentCount: this.hasInviteAgentCount,
        noInviteAgentCount: this.noInviteAgentCount,
      }
    },
  },
  watch: {
    timeTabIndex() {
      this.fetchInviteData()
    },
  },
  created() {
    this.fetchInviteData()
    this.startCarouselPoll()
  },
  methods: {
    formatJoinedDate(timestamp) {
      if (!timestamp) return '--'
      return this.handleMoment(timestamp, 'DD MMM')
    },
    mapStatItem(item) {
      return mapSubAgentStatItem(item, this.formatJoinedDate.bind(this))
    },
    loadCarouselNotices() {
      apiFetchSubAgentCarousel().then((res) => {
        this.notices = mapCarouselList((res && res.list) || [])
      })
    },
    fetchInviteData() {
      if (this.inviteLoading) return
      this.inviteLoading = true
      Promise.all([
        apiFetchSubAgentInvite(
          buildInviteParams({
            timeTabIndex: this.timeTabIndex,
            dataType: INVITE_DATA_TYPE.NEW_SUB_AGENT,
            offset: 0,
            limit: PREVIEW_FETCH_LIMIT,
          })
        ),
        apiFetchSubAgentInvite(
          buildInviteParams({
            timeTabIndex: this.timeTabIndex,
            dataType: INVITE_DATA_TYPE.PERFORMANCE,
            offset: 0,
            limit: PREVIEW_FETCH_LIMIT,
          })
        ),
      ])
        .then(([newRes, perfRes]) => {
          const newList = (newRes && newRes.newSubAgents) || []
          const perfList = (perfRes && perfRes.subAgentPerforms) || []
          this.newSubAgentCount = (newRes && newRes.newSubAgentCount) ?? 0
          this.hasInviteAgentCount = (perfRes && perfRes.hasInviteAgentCount) ?? 0
          this.newHostCount = (perfRes && perfRes.newHostCount) ?? 0
          this.noInviteAgentCount = (perfRes && perfRes.noInviteAgentCount) ?? 0
          this.showNewViewMore = newList.length > PREVIEW_DISPLAY_LIMIT
          this.showPerformanceViewMore = perfList.length > PREVIEW_DISPLAY_LIMIT
          this.newSubAgentList = newList.slice(0, PREVIEW_DISPLAY_LIMIT).map((item) => this.mapStatItem(item))
          this.performanceList = perfList.slice(0, PREVIEW_DISPLAY_LIMIT).map((item) => this.mapStatItem(item))
        })
        .finally(() => {
          this.inviteLoading = false
        })
    },
    handleCopyId(id) {
      this.handleCopy(id, this.$t('lang.BaseCommon.k071'))
    },
    goNewSubAgentPage() {
      this.$router.push({
        path: '/invite-sub-agent-new',
        query: {
          statusBarHeight: this.$route.query.statusBarHeight,
          timeTabIndex: this.timeTabIndex,
        },
      })
    },
    goPerformancePage() {
      this.$router.push({
        path: '/invite-sub-agent-performance',
        query: {
          statusBarHeight: this.$route.query.statusBarHeight,
          timeTabIndex: this.timeTabIndex,
        },
      })
    },
    handleTimeTab(index) {
      this.timeTabIndex = index
      this.$nextTick(() => {
        const tabList = this.$refs.timeTabList
        const tabRef = this.$refs[`timeTab-${index}`]
        const tabEl = Array.isArray(tabRef) ? tabRef[0] : tabRef
        if (tabList && tabEl) {
          const listRect = tabList.getBoundingClientRect()
          const tabRect = tabEl.getBoundingClientRect()
          const offset = tabRect.left - listRect.left - (listRect.width - tabRect.width) / 2
          tabList.scrollTo({ left: tabList.scrollLeft + offset, behavior: 'smooth' })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.sub-agent-invite-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 12px;

  .time-tab-wrap {
    width: 100%;
    position: relative;

    .time-switch-tab {
      display: flex;
      align-items: center;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      .time-tab {
        flex-shrink: 0;
        padding: 8px 16px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #b2b2b2;
        white-space: nowrap;
        text-align: center;

        &.active-tab {
          background: #f1e8d9;
          border-radius: 36px;
          color: #925e0d;
        }
      }
    }
  }

  :deep(.sub-agent-notice-bar) {
    margin-top: 16px;
  }

  .data-section {
    display: flex;
    flex-direction: column;
    padding: 4px 0;
    margin-top: 16px;

    .section-header {
      display: flex;
      align-items: center;
      padding: 4px 0;

      .section-title {
        margin-inline-start: 4px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-20);
        line-height: 26px;
        color: #333333;
      }

      .section-bar {
        width: 4px;
        height: 14px;
        background: #925e0d;
        border-radius: 2px;
        flex-shrink: 0;
      }
    }

    .stat-cards {
      display: flex;
      padding: 4px 0;

      &.stat-cards-row {
        .stat-card-row {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 4px 14px;
          background: linear-gradient(180deg, #fff0d9 0%, #fefcf8 100%);
          border-radius: 12px;
          box-sizing: border-box;

          .stat-value {
            margin-inline-start: 8px;
            flex-shrink: 0;
            font-family: var(--number-font);
            font-weight: var(--fw-400);
            font-size: 24px;
            line-height: 32px;
            color: #925e0d;
          }

          .stat-label {
            flex: 1;
            min-width: 0;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-body-18);
            color: #ad8a55;
          }
        }
      }

      &.three-cols {
        .stat-card + .stat-card {
          margin-inline-start: 8px;
        }

        .stat-card {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          min-height: 86px;
          padding: 12px 10px;
          background: linear-gradient(180deg, #fff0d9 0%, #fefcf8 100%);
          border-radius: 12px;
          box-sizing: border-box;

          .stat-label {
            margin-top: 4px;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-body-18);
            letter-spacing: 0px;
            color: #ad8a55;

            p {
              margin: 0;
            }
          }

          .stat-value {
            flex: 1;
            font-family: var(--number-font);
            font-weight: var(--fw-400);
            font-size: 24px;
            line-height: 32px;
            color: #925e0d;
          }
        }
      }
    }

    .data-table {
      border: 2px solid #f9f8f6;
      border-radius: 8px;
      overflow: hidden;
      width: 100%;
      margin-top: 8px;
      background: transparent;

      .table-header {
        display: grid;
        grid-template-columns: 38% 32% 30%;

        .th {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          min-width: 0;
          padding: 8px 8px;
          background: #f9f8f6;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-title-20);
          color: #925e0d;
          text-align: center;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;

          &.th-agent {
            justify-content: center;
          }

          &:nth-child(2) {
            border-inline-start: 1.5px solid #edeae3;
          }

          &:nth-child(3) {
            border-inline-start: 1.5px solid #edeae3;
          }
        }
      }

      .table-row {
        display: grid;
        grid-template-columns: 38% 32% 30%;

        &:last-child .td {
          border-bottom: none;
        }
      }

      .td {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 8px;
        border-bottom: 1.5px solid #f9f8f6;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-12);
        line-height: var(--lh-label-16);
        color: #333333;
        align-self: stretch;

        &.td-agent {
          flex-direction: column;
          align-items: start;
          padding: 12px 8px;

          .agent-id-row {
            margin-top: 8px;
            display: inline-flex;
            align-items: center;
            max-width: 100%;
            color: #b2b2b2;

            span {
              white-space: nowrap;
              overflow: visible;
            }

            .copy-icon {
              margin-inline-start: 2px;
              width: 16px;
              height: 16px;
              flex-shrink: 0;
            }
          }

          .agent-name-row {
            display: inline-flex;
            align-items: center;
            max-width: 100%;
            min-width: 0;

            .country-icon {
              margin-inline-start: 2px;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              flex-shrink: 0;
            }

            .agent-name {
              flex: 0 1 auto;
              max-width: 80px;
              font-size: var(--fs-14);
              line-height: var(--lh-title-20);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        &.td-center {
          min-width: 0;
          flex-wrap: wrap;
          align-content: center;
          text-align: center;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
        }
      }

      .table-empty {
        min-height: 120px;
        background: #fefefe;
      }
    }

    .view-more {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 12px 10px;
      margin-top: 6px;
      background: linear-gradient(-70.96deg, #f6ddb9 0%, #f5efd9 100%);
      border-radius: 8px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-12);
      line-height: var(--lh-body-18);
      color: #925e0d;
      cursor: pointer;

      .view-more-arrow {
        margin-inline-start: 4px;
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }
    }
  }

  .section-divider {
    width: 100%;
    height: 1px;
    background: #eeeeee;
    margin: 4px 0;
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .sub-agent-invite-panel {
    .data-section {
      .view-more {
        background: linear-gradient(70.96deg, #f6ddb9 0%, #f5efd9 100%);
      }
    }
  }
}
</style>
